import { Component, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-modal-ajuda-ativacao-kriptonita',
  templateUrl: './modal-ajuda-ativacao-kriptonita.component.html',
  styleUrls: ['./modal-ajuda-ativacao-kriptonita.component.css']
})
export class ModalAjudaAtivacaoKriptonitaComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ModalAjudaAtivacaoKriptonitaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
  }

  onClose() {
    this.dialogRef.close();
  }

}
